import { useState } from 'react';
import { REPORT_REASONS, type ReportReason } from '@repo/shared/domain';
import { REPORT_REASON_LABELS } from '../labels.ts';
import { Modal } from './Modal.tsx';

interface ReportDialogProps {
  onSubmit: (reason: ReportReason) => void;
  onClose: () => void;
}

export function ReportDialog({ onSubmit, onClose }: ReportDialogProps) {
  const [reason, setReason] = useState<ReportReason | null>(null);

  return (
    <Modal title="Person melden" onClose={onClose}>
      <p className="dialog__text">
        Die Verbindung wird sofort getrennt. Die Person erfährt nicht, dass du sie gemeldet hast,
        und begegnet dir so schnell nicht wieder.
      </p>
      <div className="reasons" role="radiogroup" aria-label="Grund der Meldung">
        {REPORT_REASONS.map((value) => (
          <label key={value} className="reason">
            <input
              type="radio"
              name="report-reason"
              checked={reason === value}
              onChange={() => setReason(value)}
            />
            {REPORT_REASON_LABELS[value]}
          </label>
        ))}
      </div>
      <div className="dialog__actions">
        <button type="button" className="button button--ghost" onClick={onClose}>
          Abbrechen
        </button>
        <button
          type="button"
          className="button button--danger"
          disabled={reason === null}
          onClick={() => reason && onSubmit(reason)}
        >
          Melden und weiter
        </button>
      </div>
    </Modal>
  );
}
